import request from '@/utils/request'


// 查询动态可充值列列表
export function listRechargeAble(query) {
  return request({
    url: '/zb/recharge/able/list',
    method: 'get',
    params: query
  })
}

// 查询动态可充值列分页
export function pageRechargeAble(query) {
  return request({
    url: '/zb/recharge/able/page',
    method: 'get',
    params: query
  })
}

// 查询动态可充值列详细
export function getRechargeAble(data) {
  return request({
    url: '/zb/recharge/able/detail',
    method: 'get',
    params: data
  })
}

// 新增动态可充值列
export function addRechargeAble(data) {
  return request({
    url: '/zb/recharge/able/add',
    method: 'post',
    data: data
  })
}

// 修改动态可充值列
export function updateRechargeAble(data) {
  return request({
    url: '/zb/recharge/able/edit',
    method: 'post',
    data: data
  })
}

// 删除动态可充值列
export function delRechargeAble(data) {
  return request({
    url: '/zb/recharge/able/delete',
    method: 'post',
    data: data
  })
}
